import { motion } from "framer-motion";
import { ShieldCheck, Lock, ServerOff } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const SIGNALS = [
  {
    icon: ServerOff,
    label: "Zero retention",
    body: "Files are processed in memory and vanish the moment your download completes. No archives, no exceptions.",
    testid: "trust-retention",
  },
  {
    icon: Lock,
    label: "AES-256 protection",
    body: "Bank-grade encryption the moment you password-protect a document — keys never touch our servers.",
    testid: "trust-encryption",
  },
  {
    icon: ShieldCheck,
    label: "Stripe-secured billing",
    body: "Payments run entirely through Stripe. Your card details never pass through Doclyx infrastructure.",
    testid: "trust-billing",
  },
];

export const TrustBar = () => (
  <section className="border-b border-hairline" data-testid="trust-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
      {SIGNALS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
          className="flex items-start gap-5"
          data-testid={s.testid}
        >
          <span className="w-11 h-11 rounded-full border border-hairline flex items-center justify-center shrink-0">
            <s.icon className="w-5 h-5 text-azure" strokeWidth={1.5} />
          </span>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink mb-2">{s.label}</p>
            <p className="text-sm text-fog leading-relaxed">{s.body}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
